import { List, ListItem } from '@mui/material'
import styled from 'styled-components'

export const FilterList = styled(List)`
  width: 100%;
  padding: 0 !important;
  padding-bottom: 16px !important;
`

export const FilterListItem = styled(ListItem)`
  padding: 8px 0 !important;

  &:first-child {
    padding-top: 0 !important;
  }

  &:last-child {
    padding-bottom: 0 !important;
  }
`
